import { ReactComponent } from "/builds/mb/front/src/app/assets/images/applyOfferBand.svg?react";
import url from "/builds/mb/front/src/app/assets/images/applyOfferBand.svg?url";
export { ReactComponent };
export default url;
